import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyboardComponent } from './keyboard.component';
import { KeyboardTileComponent } from './keyboard-tile/keyboard-tile.component';

@NgModule({
  declarations: [
    KeyboardComponent,
    KeyboardTileComponent
    // declare the KeyboardComponent
  ],
  imports: [
    CommonModule,  // import CommonModule to have access to common directives like ngIf, ngFor
  ],
  exports: [
    KeyboardComponent,  // export KeyboardComponent so it can be used in other modules
  ]
})
export class SharedModule { }